"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationWarningType = exports.SdqProsocialBand = exports.SdqDifficultiesBand = exports.SdqRunStatus = exports.SdqConductChannel = exports.SdqConductMode = exports.MeasurementUnit = exports.TestTaskType = exports.SportsClubMembership = exports.Gender = exports.AttendanceStatus = exports.TestStatus = exports.OrgRole = exports.TwoFactorMethod = exports.UserType = exports.UserRole = void 0;
__exportStar(require("./federal-state"), exports);
__exportStar(require("./admin-data"), exports);
__exportStar(require("./charts"), exports);
__exportStar(require("./chart-map"), exports);
__exportStar(require("./chart-weight"), exports);
__exportStar(require("./chart-compare"), exports);
__exportStar(require("./chart-overview"), exports);
__exportStar(require("./chart-colors"), exports);
__exportStar(require("./chart-axis"), exports);
__exportStar(require("./chart-dates"), exports);
__exportStar(require("./gpfit-colors"), exports);
__exportStar(require("./stanine"), exports);
__exportStar(require("./z-profile"), exports);
__exportStar(require("./austria-map"), exports);
__exportStar(require("./austria-districts"), exports);
__exportStar(require("./chart-map-drilldown"), exports);
__exportStar(require("./school-level"), exports);
__exportStar(require("./weight-class"), exports);
__exportStar(require("./test-deletion"), exports);
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["USER"] = "USER";
})(UserRole || (exports.UserRole = UserRole = {}));
var UserType;
(function (UserType) {
    UserType["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserType["ORG_USER"] = "ORG_USER";
})(UserType || (exports.UserType = UserType = {}));
var TwoFactorMethod;
(function (TwoFactorMethod) {
    TwoFactorMethod["SMS"] = "SMS";
    TwoFactorMethod["TOTP"] = "TOTP";
})(TwoFactorMethod || (exports.TwoFactorMethod = TwoFactorMethod = {}));
var OrgRole;
(function (OrgRole) {
    OrgRole["ADMINISTRATIVE"] = "ADMINISTRATIVE";
    OrgRole["TEACHER"] = "TEACHER";
    OrgRole["TRAINER"] = "TRAINER";
})(OrgRole || (exports.OrgRole = OrgRole = {}));
var TestStatus;
(function (TestStatus) {
    TestStatus["SCHEDULED"] = "SCHEDULED";
    TestStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TestStatus["COMPLETED"] = "COMPLETED";
    TestStatus["CANCELLED"] = "CANCELLED";
})(TestStatus || (exports.TestStatus = TestStatus = {}));
var AttendanceStatus;
(function (AttendanceStatus) {
    AttendanceStatus["PRESENT"] = "PRESENT";
    AttendanceStatus["ABSENT"] = "ABSENT";
    AttendanceStatus["NOT_MARKED"] = "NOT_MARKED";
})(AttendanceStatus || (exports.AttendanceStatus = AttendanceStatus = {}));
var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (exports.Gender = Gender = {}));
var SportsClubMembership;
(function (SportsClubMembership) {
    SportsClubMembership["YES"] = "YES";
    SportsClubMembership["NO"] = "NO";
    SportsClubMembership["UNKNOWN"] = "UNKNOWN";
})(SportsClubMembership || (exports.SportsClubMembership = SportsClubMembership = {}));
var TestTaskType;
(function (TestTaskType) {
    TestTaskType["HEIGHT"] = "HEIGHT";
    TestTaskType["WEIGHT"] = "WEIGHT";
    TestTaskType["WAIST_CIRCUMFERENCE"] = "WAIST_CIRCUMFERENCE";
    TestTaskType["SITTING_HEIGHT"] = "SITTING_HEIGHT";
    TestTaskType["GRIP_HEIGHT"] = "GRIP_HEIGHT";
    TestTaskType["STANDING_LONG_JUMP"] = "STANDING_LONG_JUMP";
    TestTaskType["PUSHUPS"] = "PUSHUPS";
    TestTaskType["SIX_MINUTE_RUN"] = "SIX_MINUTE_RUN";
    TestTaskType["SIDEWAYS_JUMPING"] = "SIDEWAYS_JUMPING";
    TestTaskType["FOUR_X_TEN_M_SPRINT"] = "FOUR_X_TEN_M_SPRINT";
    TestTaskType["MEDICINE_BALL_THROW"] = "MEDICINE_BALL_THROW";
    TestTaskType["POLE_CLIMBING"] = "POLE_CLIMBING";
    TestTaskType["SIT_AND_REACH"] = "SIT_AND_REACH";
    TestTaskType["BALANCE_TEST"] = "BALANCE_TEST";
    TestTaskType["MENTAL_HEALTH"] = "MENTAL_HEALTH";
})(TestTaskType || (exports.TestTaskType = TestTaskType = {}));
var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit["CM"] = "CM";
    MeasurementUnit["KG"] = "KG";
    MeasurementUnit["REPS"] = "REPS";
    MeasurementUnit["METERS"] = "METERS";
    MeasurementUnit["SECONDS"] = "SECONDS";
    MeasurementUnit["POINTS"] = "POINTS";
})(MeasurementUnit || (exports.MeasurementUnit = MeasurementUnit = {}));
// --- Mentale Gesundheit (SDQ) ---
var SdqConductMode;
(function (SdqConductMode) {
    SdqConductMode["VIDEO"] = "VIDEO";
    SdqConductMode["TEXT"] = "TEXT";
})(SdqConductMode || (exports.SdqConductMode = SdqConductMode = {}));
var SdqConductChannel;
(function (SdqConductChannel) {
    SdqConductChannel["IN_SOFTWARE"] = "IN_SOFTWARE";
    SdqConductChannel["PUBLIC_LINK"] = "PUBLIC_LINK";
})(SdqConductChannel || (exports.SdqConductChannel = SdqConductChannel = {}));
var SdqRunStatus;
(function (SdqRunStatus) {
    SdqRunStatus["IN_PROGRESS"] = "IN_PROGRESS";
    SdqRunStatus["COMPLETED"] = "COMPLETED";
})(SdqRunStatus || (exports.SdqRunStatus = SdqRunStatus = {}));
var SdqDifficultiesBand;
(function (SdqDifficultiesBand) {
    SdqDifficultiesBand["GREEN"] = "GREEN";
    SdqDifficultiesBand["YELLOW"] = "YELLOW";
    SdqDifficultiesBand["RED"] = "RED";
})(SdqDifficultiesBand || (exports.SdqDifficultiesBand = SdqDifficultiesBand = {}));
var SdqProsocialBand;
(function (SdqProsocialBand) {
    SdqProsocialBand["GREAT"] = "GREAT";
    SdqProsocialBand["MIDDLE"] = "MIDDLE";
    SdqProsocialBand["NEEDS_PRACTICE"] = "NEEDS_PRACTICE";
})(SdqProsocialBand || (exports.SdqProsocialBand = SdqProsocialBand = {}));
var CalculationWarningType;
(function (CalculationWarningType) {
    CalculationWarningType["MISSING_GENDER"] = "MISSING_GENDER";
    CalculationWarningType["AGE_OUT_OF_RANGE"] = "AGE_OUT_OF_RANGE";
    CalculationWarningType["INVALID_BALL_WEIGHT_FOR_AGE"] = "INVALID_BALL_WEIGHT_FOR_AGE";
    CalculationWarningType["MISSING_EQUIPMENT_CONFIG"] = "MISSING_EQUIPMENT_CONFIG";
    CalculationWarningType["NO_NORMATIVE_DATA"] = "NO_NORMATIVE_DATA";
})(CalculationWarningType || (exports.CalculationWarningType = CalculationWarningType = {}));
